import { fleetManagementApi } from "../api";

const BOOKING_EXPENSES_ENDPOINT = "/booking-expenses";

export const getBookingExpenses = async (params) => {
  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    const response = await fleetManagementApi.get(`${BOOKING_EXPENSES_ENDPOINT}?${queryParams}`);
    return response;
  }
  const response = await fleetManagementApi.get(BOOKING_EXPENSES_ENDPOINT);
  return response;
};

export const getBookingExpenseById = async (bookingExpenseId) => {
  const response = await fleetManagementApi.get(`${BOOKING_EXPENSES_ENDPOINT}/${bookingExpenseId}`);
  return response;
};

export const createBookingExpense = async (bookingExpenseData) => {
  const response = await fleetManagementApi.post(BOOKING_EXPENSES_ENDPOINT, bookingExpenseData);
  return response;
};

export const updateBookingExpense = async (bookingExpenseId, bookingExpenseData) => {
  const response = await fleetManagementApi.put(
    `${BOOKING_EXPENSES_ENDPOINT}/${bookingExpenseId}`,
    bookingExpenseData
  );
  return response;
};

export const deleteBookingExpense = async (bookingExpenseId) => {
  const response = await fleetManagementApi.delete(`${BOOKING_EXPENSES_ENDPOINT}/${bookingExpenseId}`);
  return response;
};
